import { LoyaltyTagSectionAPIPromiseClient } from "gen/witbooking/loyalty/tag/v1/loyalty_tag_api_grpc_web_pb";
import {
  CreateTagSectionRequest,
  DeleteTagSectionRequest,
  GetTagSectionRequest,
  ListTagSectionsRequest,
  ReorderTagSectionRequest,
  UpdateTagSectionRequest,
} from "gen/witbooking/loyalty/tag/v1/loyalty_tag_api_pb";
import { LoyaltyTagSection } from "../../domain/LoyaltyTagSection";
import { LoyaltyTagSectionMapper } from "../mappers/LoyaltyTagSectionMapper";

export class LoyaltyTagSectionGateway {
  constructor(private readonly grpcClient: LoyaltyTagSectionAPIPromiseClient) {}

  async getAll(brandId: string): Promise<LoyaltyTagSection[]> {
    console.debug(`getting all sections for brand [${brandId}]`);
    const request = new ListTagSectionsRequest();
    request.setBrandid(brandId);

    return (await this.grpcClient.listTagSections(request))
      .getSectionsList()
      .map(LoyaltyTagSectionMapper.fromGrpc);
  }

  async get(brandId: string, id: string): Promise<LoyaltyTagSection> {
    console.debug(`getting section [${id}] for brand [${brandId}]`);
    const request = new GetTagSectionRequest();
    request.setBrandid(brandId);
    request.setId(id);

    const section = (await this.grpcClient.getTagSection(request)).getSection();
    if (!section) throw new Error(`Section [${id}] not found`);

    return LoyaltyTagSectionMapper.fromGrpc(section);
  }

  async save(brandId: string, section: LoyaltyTagSection): Promise<void> {
    console.debug(`saving section [${section.id}]`);
    const request = new CreateTagSectionRequest();
    request.setBrandid(brandId);
    request.setSection(LoyaltyTagSectionMapper.toGrpc(brandId, section));

    await this.grpcClient.createTagSection(request);
  }

  async update(brandId: string, section: LoyaltyTagSection): Promise<void> {
    console.debug(`updating section [${section.id}]`);
    const request = new UpdateTagSectionRequest();
    request.setBrandid(brandId);
    request.setSection(LoyaltyTagSectionMapper.toGrpc(brandId, section));

    await this.grpcClient.updateTagSection(request);
  }

  async reorder(brandId: string, id: string, after?: string): Promise<void> {
    console.debug(`reorder [${id}] -> [${after}]`);
    const request = new ReorderTagSectionRequest();
    request.setBrandid(brandId);
    request.setId(id);
    if (after) {
      request.setAfterid(after);
    }

    await this.grpcClient.reorderTagSection(request);
  }

  async delete(brandId: string, id: string): Promise<void> {
    console.debug(`deleting section [${id}]`);
    const request = new DeleteTagSectionRequest();
    request.setBrandid(brandId);
    request.setId(id);

    await this.grpcClient.deleteTagSection(request);
  }
}
